// extracted by mini-css-extract-plugin
module.exports = {"invent":"invent_invent__3zEW3","content":"invent_content__1Az3b","select":"invent_select__1MYbI","materialsCategoryCascader":"invent_materialsCategoryCascader__2Q9_s"};